require('./dist/angular-toastr.tpls.js');
module.exports = 'toastr';




//////////////////
// WEBPACK FOOTER
// ./~/angular-toastr/index.js
// module id = 269
// module chunks = 1